module.exports = __webpack_public_path__ + "static/media/Photo 2020-02-11, 10 22 42 AM.4874fb99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Photo 2020-02-11, 10 22 42 AM.jpg
// module id = 379
// module chunks = 0